var map = {
  "./critical.png": "66871",
  "./guestadom_idx.png": "69725",
  "./high.png": "33384",
  "./logo.png": "33153",
  "./low.png": "68540",
  "./medium.png": "13917",
  "./signature.png": "45016",
  "./waiting.png": "6327",
  "./yaago.png": "79351"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 50715;
